import { ANNOTATION_PROVIDERS } from 'components/OrderSlidesList/ExtAnnotations/constants';
import {
  GEOJSON_FILE_EXTENSION,
  HALO_ANNOTATIONS_FILE_EXTENSION,
  IMAGE_SCOPE_ANNOTATIONS_FILE_EXTENSION,
} from 'components/ImageViewer/constants';

export const uploadExtAnnotations = ({
  selectedProvider,
  files,
  setPreparedForUpload,
}) => {
  const { icon, provider } = ANNOTATION_PROVIDERS.find(
    ({ name }) => name === selectedProvider,
  );
  const filesToAttach = files
    .filter(
      (file) =>
        file.name.endsWith(GEOJSON_FILE_EXTENSION) ||
        file.name.endsWith(HALO_ANNOTATIONS_FILE_EXTENSION) ||
        file.name.endsWith(IMAGE_SCOPE_ANNOTATIONS_FILE_EXTENSION),
    )
    .map((file) => ({
      fileName: file.name,
      icon,
      type: provider,
      file,
    }));
  setPreparedForUpload((prev) => {
    const filesToAdd = filesToAttach.filter(
      ({ fileName, type }) =>
        !prev.some((item) => item.fileName === fileName && item.type === type),
    );

    return [...prev, ...filesToAdd];
  });
};
